/* eslint-disable  no-prototype-builtins,jsx-a11y/control-has-associated-label */

import React, { useState, useEffect } from 'react';
import ID from './UUID';
import './DynamicOptionList.css';
// import option from './language-provider/option';



const DynamicOptionList = (props) => {
    const {element:reNamePropsElement, updateElement:propsupdateElement,preview:propspreview,canHaveOptionValue:propscanHaveOptionValue,canHaveOptionCorrect:propscanHaveOptionCorrect} = props || {}
    const [element, setElement] = useState(reNamePropsElement);
    const [dirty, setDirty] = useState(false);

    useEffect(() => {
        setElement(reNamePropsElement);
    }, [reNamePropsElement]);

    const _setValue = (text) => {
        return text.replace(/[^A-Z0-9]+/ig, '_').toLowerCase();
    };

    const editOption = (index, e) => {
        const updatedElement = { ...element };
        const option = updatedElement.options[index];
        const val = (option.value !== _setValue(option.text)) ? option.value : _setValue(e.target.value);

        option.text = e.target.value;
        option.value = val;

        setElement(updatedElement);
        setDirty(true);
    };

    const editValue = (index, e) => {
        const updatedElement = { ...element };
        const option = updatedElement.options[index];
        option.value = e.target.value === '' ? _setValue(option.text) : e.target.value;

        setElement(updatedElement);
        setDirty(true);
    };

    const editOptionCorrect = (index) => {
        const updatedElement = { ...element };
        const option = updatedElement.options[index];

        if (option.hasOwnProperty('correct')) {
            delete option.correct;
        } else {
            option.correct = true;
        }

        setElement(updatedElement);
        propsupdateElement.call(propspreview, updatedElement);
    };

    const updateOption = () => {
        if (dirty) {
            propsupdateElement.call(propspreview, element);
            setDirty(false);
        }
    };

    const addOption = (index) => {
        const updatedElement = { ...element };
        const groupKey = updatedElement.element.toLowerCase();
        updatedElement.options.splice(index + 1, 0, {
            value: '',
            text: '',
            key: `${groupKey}_option_${ID.uuid()}`
        });

        setElement(updatedElement);
        propsupdateElement.call(propspreview, updatedElement);
    };

    const removeOption = (index) => {
        const updatedElement = { ...element };
        updatedElement.options.splice(index, 1);

        setElement(updatedElement);
        propsupdateElement.call(propspreview, updatedElement);
    };

    if (dirty) {
        element.dirty = true;
    }

    return (
        <div className="dynamic-option-list">
            <ul>
                <li>
                    <div className="row">
                        <div className="colsm6"><b><div id='options'></div></b></div>
                        {propscanHaveOptionValue &&
                            <div className="colsm2"><b><p id='value' /></b></div>}
                        {propscanHaveOptionValue && propscanHaveOptionCorrect &&
                            <div className="colsm4"><b><p id='correct' /></b></div>}
                    </div>
                </li>
                {element.options.map((option, index) => {
                    const this_key = `edit_${option.key}`;
                    const val = (option.value !== _setValue(option.text)) ? option.value : '';

                    return (
                        <li className="clearfix" key={this_key}>
                            <div className="row_grid">
                            <div className="colsm6">
                                <input
                                    tabIndex={index + 1}
                                    className="form-control"
                                    style={{ width: '100%' }}
                                    type="text"
                                    name={`text_${index}`}
                                    placeholder="Option text"
                                    value={option.text}
                                    onBlur={updateOption}
                                    onChange={(e) => editOption(index, e)}
                                />
                            </div>
                            {propscanHaveOptionValue &&
                                <div className="colsm2">
                                    <input
                                        className="form-control"
                                        type="text"
                                        name={`value_${index}`}
                                        value={val}
                                        onChange={(e) => editValue(index, e)}
                                    />
                                </div>}
                            {propscanHaveOptionValue && propscanHaveOptionCorrect &&
                                <div className="colsm1">
                                    <input
                                        className="form-control"
                                        type="checkbox"
                                        value="1"
                                        onChange={() => editOptionCorrect(index)}
                                        checked={option.hasOwnProperty('correct')}
                                    />
                                </div>}
                            <div className="colsm3">
                                <div className="dynamic-options-actions-buttons">
                                    <button type='button' onClick={() => addOption(index)} className="btn btn-success">
                                        <i className="fas fa-plus-circle"></i>
                                    </button>
                                    {index > 0 &&
                                        <button type='button' onClick={() => removeOption(index)} className="btn btn-danger">
                                            <i className="fas fa-minus-circle"></i>
                                        </button>}
                                </div>
                            </div>
                        </div>
            </li>
            );
        })}
        </ul>
    </div >
  );
};



export default DynamicOptionList